import { i18n } from '@/plugins/i18n'
import api from '@/auth/api'
const { t } = i18n.global
import { createRouter, createWebHistory } from "vue-router"
import { useLangStore } from '@/store/lang'


import PublicLayout from "@/modules/public/layout/PublicLayout.vue"
import AuthServicesLayout from "@/modules/authservices/layout/AuthServicesLayout.vue"
import AdminLayout from "@/modules/admin/layout/AdminLayout.vue"
import CustomerDashboardLayout from "@/modules/dashboard/layout/CustomerDashboardLayout.vue"
import FinanceSetupLayout from '@/modules/financesetup/layout/FinanceSetupLayout.vue'
import FinanceLayout from '@/modules/finance/layout/FinanceLayout.vue'
import InventoryLogisticsLayout from '@/modules/inventorylogistics/layout/InventoryLogisticsLayout.vue'
import ProcurementLayout from '@/modules/procurement/layout/ProcurementLayout.vue'
import PayrollLayout from '@/modules/payroll/layout/PayrollLayout.vue'
import SalesLayout from '@/modules/sales/layout/SalesLayout.vue'
import HrLayout from '@/modules/hr/layout/HrLayout.vue'
import ProductionLayout from '@/modules/production/layout/ProductionLayout.vue'
import CrmLayout from '@/modules/crm/layout/CrmLayout.vue'
import ClinicalLayout from '@/modules/clinical/layout/ClinicalLayout.vue'
import SaaSHostingLayout from '@/modules/hosting/layout/SaaSHostingLayout.vue'
import PosLayout from '@/modules/pos/layout/PosLayout.vue'
import HelpdeskLayout from '@/modules/helpdesk/layout/HelpdeskLayout.vue'


// -------------------------------------------------------
// ROUTES
// -------------------------------------------------------
const routes = [

  // ROOT REDIRECT
  {
    path: "/",
    redirect: () => {
      const lanStore = useLangStore.currentLanguage
      return `/${lanStore}/`
    }
  },

  // AUTH FIRST
  {
    path: "/:lang(en|fr)/auth",
    component: AuthServicesLayout,
    meta: { layout: AuthServicesLayout, public: true },
    children: [
      { path: "login", name: "Login", component: () => import("@/modules/authservices/pages/LoginView.vue") },
      { path: "self-service-account-creation", name: "SelfServiceCreateAccount", component: () => import("@/modules/authservices/pages/NbRegisterUserSelfService.vue") },
      { path: "logout", name: "Logout", component: () => import("@/modules/authservices/pages/LogOut.vue") },
      { path: "request-reset-password", name: "RequestPasswordReset", component: () => import("@/modules/authservices/pages/RequestPasswordReset.vue") },
      { path: "reset-password", name: "ResetPassword", component: () => import("@/modules/authservices/pages/ResetPassword.vue"),   props: route => ({
        token: route.query.token || null
        }) 
      },
      { path: "resend-email-otp", name: "ResendEmailOtp", component: () => import("@/modules/authservices/pages/ResendEmailOtp.vue") },
      { path: "mfa-setup/:username", name: "MfaSetup", component: () => import("@/modules/authservices/pages/TestSetupMfa.vue") },
      { path: "mfa-verify/:username", name: "MfaVerify", component: () => import("@/modules/authservices/pages/TestVerifyMfa.vue") },
      { path: "verify-email-otp/:username", name: "EmailVerifyOtp", component: () => import("@/modules/authservices/pages/VerifyEmailOtp.vue") }
    ]
  },

    // ADMIN SECOND
  {
    path: "/:lang(en|fr)/admin",
    component: AdminLayout,
    meta: { layout: AdminLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "AdminDashboard",
        component: () => import("@/modules/admin/pages/DashboardView.vue")
      },
      {
        path: "staff-onboarding",
        name: "StaffOnbording",
        component: () => import("@/modules/admin/pages/StaffManagementPage.vue"),
      },
      {
        path: "clients-onboarding",
        name: "PatientsOnbording",
        component: () => import("@/modules/admin/pages/PatientsManagementPage.vue"),
      },
       {
        path: "staff-onboarding",
        name: "roles",
        component: () => import("@/modules/admin/pages/RolesManagementPage.vue"),
      },
      {
        path: "permissions",
        name: "AdminPermissions",
        component: () => import("@/modules/admin/pages/ManagePermissions.vue"),
      },

      {
        path: "assign-role-permissions",
        name: "AdminAssignRolePermissions",
        component: () => import("@/modules/admin/pages/RolesManagementPage.vue"),
      },
        // general setup
      { path: 'years', name: 'Years', component: () => import('@/modules/admin/components/NbYears.vue') },
      { path: 'generate-qrcode', name: 'QRCode', component: () => import('@/modules/admin/components/BarCodegenerator.vue') },
      //-create sidebar menu
      { path: 'side-bar-menu', name: 'sideBarMenuEN', component: () => import('@/modules/admin/pages/SidebarMenu.vue'), 
      },
      { path: 'menu-lateral', name: 'sideBarMenuFR', component: () => import('@/modules/admin/pages/SidebarMenu.vue'), 
      },
      //-create sidebar menu l1
      { path: 'side-bar-menu-level-one', name: 'sideBarMenuLevelOneEN', component: () => import('@/modules/admin/pages/SidebarMenu.vue'), 
      },
      { path: 'menu-de-la-barre-laterale-niveau-un', name: 'sideBarMenuLevelOneFR', component: () => import('@/modules/admin/pages/SidebarMenu.vue'), 
      },
      //-create sidebar menu l2 google time.
      { path: 'side-bar-menu-level-two', name: 'sideBarMenuLTwoEN', component: () => import('@/modules/admin/pages/SidebarMenu.vue'), 
      },
      { path: 'menu-lateral-niveau-deux', name: 'sideBarMenuLTwoFR', component: () => import('@/modules/admin/pages/SidebarMenu.vue'), 
      },

        //-System Topograph Configuration.
      { path: 'system-typography-configuration', name: 'SystemTypographyConfigurationEN', component: () => import('@/modules/admin/pages/SystemTypographyConfiguration.vue'), 
      },
      { path: 'system-typography-configuration-fr', name: 'SystemTypographyConfigurationFR', component: () => import('@/modules/admin/pages/SystemTypographyConfiguration.vue'), 
      },

      

      //-----------------------Reference filessdfsdf------------------------------------/
    //-create years
    { path: 'years', name: 'yearsEN', component: () => import('@/modules/authservices/pages/YearsOps.vue'), 
    },
    { path: 'annees', name: 'yearsFR', component: () => import('@/modules/authservices/pages/YearsOps.vue'), 
    },

   

    
    //-create message settings
    { path: 'message-setting', name: 'messageSettingsEN', component: () => import('@/modules/admin/pages/MessageSettings.vue'), 
    },
    { path: 'reglage-des-messages', name: 'messageSettingsFR', component: () => import('@/modules/admin/pages/MessageSettings.vue'), 
    },

    { path: 'tenant-membership', name: 'TenantMembershipEN', component: () => import('@/modules/admin/pages/TenantUserMembership.vue'), 
    },
    { path: 'tenant-membership-fr', name: 'TenantMembershipFR', component: () => import('@/modules/admin/pages/TenantUserMembership.vue'), 

    },
    { path: 'tenant-membership-tier', name: 'TenantMembershipTierEN', component: () => import('@/modules/admin/pages/MembershipTiers.vue'), 
    },
    { path: 'tenant-membership-tier-fr', name: 'TenantMembershipTierFR', component: () => import('@/modules/admin/pages/MembershipTiers.vue'), 
    },
    { path: 'loyalty-program', name: 'LoyaltyProgramEN', component: () => import('@/modules/admin/pages/LoyaltyProgramManagement.vue'), 
    },
    { path: 'loyalty-program-fr', name: 'LoyaltyProgramFR', component: () => import('@/modules/admin/pages/LoyaltyProgramManagement.vue'), 
    },

   

    { path: 'all-insurances', name: 'AllInsuranceEN', component: () => import('@/modules/admin/pages/AllInsurance.vue'), 
    },
    { path: 'all-insurances-fr', name: 'AllInsuranceFR', component: () => import('@/modules/admin/pages/AllInsurance.vue'), 
    },
    { path: 'user-insurance', name: 'UserInsuranceEN', component: () => import('@/modules/admin/pages/UserInsurance.vue'), 
    },
    { path: 'user-insurance-fr', name: 'UserInsuranceFR', component: () => import('@/modules/admin/pages/UserInsurance.vue'), 
    },
    { path: 'user-insurance-dependent', name: 'UserInsuranceDependentEN', component: () => import('@/modules/admin/pages/UserInsuranceDependent.vue'), 
    },
    { path: 'user-insurance-dependent-fr', name: 'UserInsuranceDependentFR', component: () => import('@/modules/admin/pages/UserInsuranceDependent.vue'), 
    },




    //-----------------OPERATIONS ROUTES------------------------------------
  
    //-A_Directory
    { path: 'all_directory', name: 'corporateDirectoryEN', component: () => import('@/modules/admin/pages/Geolocation.vue'),
    },
    { path: 'Tout_repertoire', name: 'corporateDirectoryFR', component: () => import('@/modules/admin/pages/Geolocation.vue'),
    },

    { path: 'leadership_categories/1', name: 'leadershipCatEN', component: () => import('@/modules/admin/pages/LeadershipProfiles.vue'),
    },
    { path: 'categorie-de-leadership/1', name: 'leadershipCatFR', component: () => import('@/modules/admin/pages/LeadershipProfiles.vue'),
    },
      //-Leadership
    { path: 'leadership_profiles/2', name: 'leadershipProfilesEN', component: () => import('@/modules/admin/pages/LeadershipProfiles.vue'),
    },
    { path: 'profils_de_leadership/2', name: 'leadershipProfilesFR', component: () => import('@/modules/admin/pages/LeadershipProfiles.vue'),
    },

    //-Top and Bottom area operations
    { path: 'setup-breadcrumbs', name: 'BreadCrumbsEN', component: () => import('@/modules/admin/pages/BreadcrumbsView.vue'),
    },
    { path: 'configurer-fil-ariane', name: 'BreadCrumbsFR', component: () => import('@/modules/admin/pages/BreadcrumbsView.vue'),
    },

    { path: 'top_banner', name: 'topBannerEN', component: () => import('@/modules/admin/pages/TopBannerOps.vue'),
    },
    { path: 'banniere_superieure', name: 'topBannerFR', component: () => import('@/modules/admin/pages/TopBannerOps.vue'),
    },

    { path: 'footer', name: 'footerEN', component: () => import('@/modules/admin/pages/FooterOps.vue'),
    },
    { path: 'pied_de_page', name: 'footerFR', component: () => import('@/modules/admin/pages/FooterOps.vue'),
    },

    { path: 'footer-about/1', name: 'footerAboutEN', component: () => import('@/modules/admin/pages/FooterOps.vue'),
    },
    { path: 'footer-about-fr/1', name: 'footerAboutFR', component: () => import('@/modules/admin/pages/FooterOps.vue'),
    },

    { path: 'about-us-categories/2', name: 'footerCategoriesEN', component: () => import('@/modules/admin/pages/FooterOps.vue'),
    },
    { path: 'about-us-categories-fr/2', name: 'footerCategoriesAboutFR', component: () => import('@/modules/admin/pages/FooterOps.vue'),
    },

    { path: 'footer-links/3', name: 'footerLinksEN', component: () => import('@/modules/admin/pages/FooterOps.vue'),
    },
    { path: 'footer-links-fr/3', name: 'footerLinksFR', component: () => import('@/modules/admin/pages/FooterOps.vue'),
    },

     { path: 'ai-video-studio', name: 'AIVideoStudioEN', component: () => import('@/modules/admin/pages/AIVideoStudio.vue'),
    },
    { path: 'ai-video-studio-fr', name: 'AIVideoStudioFR', component: () => import('@/modules/admin/pages/AIVideoStudio.vue'),
    },


    //- Articles
    { path: 'blogs_and_articles', name: 'blogsArticlesEN', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: 'blogs_et_articles', name: 'blogsArticlesFR', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
   
    
      //- Articles setupsdfsf
    { path: t("articles")  + '/1', name: 'ArticlesSetupEN', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: t("articles") + '/1', name: 'ArticlesSetupFR', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path:  t('articlesections') + '/2', name: 'blogArticleSectionEN', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: t('articlesections') + '/2', name: 'blogArticleSectionFR', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: t('articlefulltext' + '/3'), name: 'blogArticleFullTextEN', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: t('articlefulltext' + '/3'), name: 'blogArticleFullTextFR', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: t('articlecontributors' + '/4'), name: 'blogArticleSetupContribEN', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: t('articlecontributors' + '/4'), name: 'blogArticleSetupContribFR', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: t('authors' + '/5'), name: 'blogArticleContribEN', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },
    { path: t('authors' + '/5'), name: 'blogArticleContribFR', component: () => import('@/modules/admin/pages/BlogsArticlesOps.vue'),
    },

      //- topics and subtopics setup
    { path: 'topics/1', name: 'topicsEN', component: () => import('@/modules/admin/pages/TopicsSubtopicsOps.vue'),
    },
    { path: 'sujets/1', name: 'topicFR', component: () => import('@/modules/admin/pages/TopicsSubtopicsOps.vue'),
    },

    { path: 'sub-topic/2', name: 'subtopicsEN', component: () => import('@/modules/admin/pages/TopicsSubtopicsOps.vue'),
    },
    { path: 'sous-theme/2', name: 'subtopicFR', component: () => import('@/modules/admin/pages/TopicsSubtopicsOps.vue'),
    },

    { path: 'sub-sub-topic/3', name: 'subsubtopicsEN', component: () => import('@/modules/admin/pages/TopicsSubtopicsOps.vue'),
    },
    { path: 'sous-sous-theme/3', name: 'subsubtopicFR', component: () => import('@/modules/admin/pages/TopicsSubtopicsOps.vue'),
    },

      //- carousel slideshow
    { path: 'carousel_slideshow', name: 'carouselSlideshowEN', component: () => import('@/modules/admin/pages/CarouselSlideshowOps.vue'),
    },
    { path: 'carousel_slideshow', name: 'carouselSlideshowFR', component: () => import('@/modules/admin/pages/CarouselSlideshowOps.vue'),
    },

     { path: 'main-menu/1', name: 'MainMenuEN', component: () => import('@/modules/admin/pages/MegaMenuSetup.vue'),
    },

    { path: 'main-menu-fr/1', name: 'MainMenuFR', component: () => import('@/modules/admin/pages/MegaMenuSetup.vue'),
    },
    { path: 'mega-columns-setup/2', name: 'MegaColumnsSetupEN', component: () => import('@/modules/admin/pages/MegaMenuSetup.vue'),
    },

    { path: 'configuration-des-m&eacute;ga-colonnes/2', name: 'MegaColumnsSetupFR', component: () => import('@/modules/admin/pages/MegaMenuSetup.vue'),
    },
    { path: 'mega-items-setup/3', name: 'MegaItemSetupEN', component: () => import('@/modules/admin/pages/MegaMenuSetup.vue'),
  
    },

    { path: 'configuration-des-m&eacute;ga-&eacute;l&eacute;ment/3', name: 'MegaItemSetupFR', component: () => import('@/modules/admin/pages/MegaMenuSetup.vue'),
    },
    { path: 'mega-images-setup/4', name: 'MegaImagesSetupEN', component: () => import('@/modules/admin/pages/MegaMenuSetup.vue'),
    },

    { path: 'configuration-des-m&eacute;ga-image/4', name: 'MegaImagesSetupFR', component: () => import('@/modules/admin/pages/MegaMenuSetup.vue'),
    },

    //Course component
    //Course component
    { path: 'courses/1', name: 'courseGroupEN', component: () => import('@/modules/admin/pages/CourseManagement.vue'),

    },
    { path: 'cours/1', name: 'courseGroupFR', component: () => import('@/modules/admin/pages/CourseManagement.vue'),
    },
     { path: 'course-topics/2', name: 'courseTopicEN', component: () => import('@/modules/admin/pages/CourseManagement.vue'),
    },
    { path: 'themes-du-cours/2', name: 'courseTopicFR', component: () => import('@/modules/admin/pages/CourseManagement.vue'),

    },
     //- video player
    { path: 'video_player/3', name: 'videoPlayerEN', component: () => import('@/modules/admin/pages/CourseManagement.vue'),
    },
    { path: 'lecteur_vid&eacute;o/3', name: 'videoPlayerFR', component: () => import('@/modules/admin/pages/CourseManagement.vue'),
    },

     //List setup
    { path: 'list-caption/1', name: 'listCaptionEN', component: () => import('@/modules/admin/pages/ListManagement.vue'),
    },
    { path: 'legendesde-liste/1', name: 'listCaptionFR', component: () => import('@/modules/admin/pages/ListManagement.vue'),
    },
    { path: 'list-item/2', name: 'listItemEN', component: () => import('@/modules/admin/pages/ListManagement.vue'),
    },
    { path: 'elements-de-liste/2', name: 'listItemFR', component: () => import('@/modules/admin/pages/ListManagement.vue'),
    },
    { path: 'independent-list-item/3', name: 'independentListItemEN', component: () => import('@/modules/admin/pages/ListManagement.vue'),

    },
    { path: 'elements-de-liste-independent/3', name: 'independentListItemFR', component: () => import('@/modules/admin/pages/ListManagement.vue'),
    },

    //Themes component setup
    { path: 'themes-setup/1', name: 'ThemeSetupEN', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },
    { path: 'configuration-des-themes/1', name: 'ThemeSetupFR', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },
      { path: 'tenant-update/2', name: 'TenantUpdateEN', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },
    { path: 'tenant-update_fr/2', name: 'TenantUpdateFR', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },
    { path: 'billing-items/3', name: 'BillingItemsEN', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },
    { path: 'billing-items-fr/3', name: 'BillingItemsFR', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },
      { path: 'display-settings/4', name: 'DisplaySettingsEN', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },
    { path: 'displaysettings-fr/4', name: 'DisplaySettingsFR', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },

    { path: 'components_management', name: 'componentsMgmtEN', component: () => import('@/modules/admin/components/ComponentsOps.vue'),

    },
    { path: 'gestion_des_composants', name: 'componentsMgmtFR', component: () => import('@/modules/admin/components/ComponentsOps.vue'),
    },
      //-allsections management
    { path: 'all_sections_management', name: 'allSectionsMgmtEN', component: () => import('@/modules/admin/pages/AllsectionsOps.vue'),
    },
    { path: 'gestion_de_toutes_les_sections', name: 'allSectionsMgmtFR', component: () => import('@/modules/admin/pages/AllsectionsOps.vue'),
    },

      //-components management
    { path: 'fq_and_ans', name: 'faAndAnsEN', component: () => import('@/modules/admin/pages/FqandAnsOps.vue'),
    },
    { path: 'questions_frequentes_et_reponses', name: 'faAndAnsFR', component: () => import('@/modules/admin/pages/FqandAnsOps.vue'),
    },
      //-video player management
    { path: 'tables_captions', name: 'tableCaptionsEN', component: () => import('@/modules/admin/pages/TablesCaptionsOps.vue'),
    },
    { path: 'legendes_des_tableaux', name: 'tableCaptionFR', component: () => import('@/modules/admin/pages/TablesCaptionsOps.vue'),
    },
    //-Terms and conditions management
    { path: 'terms_privacy_cookies_policies', name: 'termsPoliciesCookiesEN', component: () => import('@/modules/admin/pages/TermspoliciesOps.vue'),
    },
    { path: 'conditions_confidentialite_cookies_politiques', name: 'termsPoliciesCookiesFR', component: () => import('@/modules/admin/pages/TermspoliciesOps.vue'),
    },
    //-Graphs management
    { path: 'graphs', name: 'graphsEN', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    { path: 'graphs-fr', name: 'graphsFR', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    //-Sales Year management
    { path: 'sales-year', name: 'salesYearEN', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    { path: 'sales-year-fr', name: 'salesYearFR', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    //-Sales Month management
    { path: 'sales-month', name: 'salesMonthEN', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    { path: 'sales-month-fr', name: 'salesMonthFR', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    //-Sales Series management
    { path: 'sales-series', name: 'salesSeriesEN', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    { path: 'sales-series-fr', name: 'salesSeriesFR', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    //-Monthly Revenue management
    { path: 'monthly-revenue', name: 'salesMonthRevenueEN', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    { path: 'monthly-revenue-fr', name: 'salesMonthlyRevenueFR', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
      //-Monthly Revenue management
    { path: 'multiline-graph', name: 'multiLineGraphEN', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    { path: 'multiline-graph-fr', name: 'multiLineGraphFR', component: () => import('@/modules/admin/pages/GraphsOps.vue'),
    },
    //-steppers management
    { path: 'steppers/1', name: 'steppersEN', component: () => import('@/modules/admin/pages/SteppersOps.vue'),
    },
    { path: 'd-etapes/1', name: 'steppersFR', component: () => import('@/modules/admin/pages/SteppersOps.vue'),
    },

    { path: 'steppers-body/2', name: 'steppersBodyEN', component: () => import('@/modules/admin/pages/SteppersOps.vue'),
    },
    { path: 'corps-des-etapes/2', name: 'steppersBodyFR', component: () => import('@/modules/admin/pages/SteppersOps.vue'),
    },

    //Manage Meeting appointments
    { path: 'organization/1', name: 'OrganizationEN', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    { path: 'Organisation/1', name: 'OrganizationFR', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    { path: 'staff/2', name: 'StaffEN', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    { path: 'Personnel/2', name: 'StaffFR', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
     { path: 'event-type/4', name: 'EventTypeEN', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    { path: 'categorie-d-evenement/4', name: 'EventTypeFR', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    { path: 'Slot-generation/5', name: 'SlotGenerationEN', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
     { path: 'Generation-de-slots/5', name: 'SlotGenerationFR', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    //- catégorie d’événement 

    
    { path: 'availability/3', name: 'AvailabilityEN', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    { path: 'availability/3', name: 'AvailabilityFR', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    { path: 'slots', name: 'SlotsEN', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },
    { path: 'disponibilité', name: 'SlotsFR', component: () => import('@/modules/admin/pages/MeetingsManagement.vue'),
    },

    //-All section ops
    { path: 'generic_all_sections', name: 'genericAllSectionsEN', component: () => import('@/modules/admin/pages/GenericSectionsops.vue'),
    },
    { path: 'générique_toutes_les_sections', name: 'genericAllSectionsFR', component: () => import('@/modules/admin/pages/GenericSectionsops.vue'),
    },

     //-All section ops
    { path: 'edge-nodes', name: 'EdgeNodeEN', component: () => import('@/modules/admin/pages/EdgeNodesView.vue'),
    },
    { path: 'edge-node-fr', name: 'EdgeNodeFR', component: () => import('@/modules/admin/pages/EdgeNodesView.vue'),
    },
    { path: 'synchronization-entities', name: 'SyncEntityEN', component: () => import('@/modules/admin/pages/SyncEntityPoliciesView.vue'),
    },
    { path: 'synchronization-entities-fr', name: 'SyncEntityFR', component: () => import('@/modules/admin/pages/SyncEntityPoliciesView.vue'),
    },

    { path: 'report-definition', name: 'ReportDefinitionEN', component: () => import('@/modules/admin/pages/ReportDefinitionsPage.vue'),
    },
    { path: 'report-definition-fr', name: 'ReportDefinitionFR', component: () => import('@/modules/admin/pages/ReportDefinitionsPage.vue'),
    },

     { path: 'report-query-definition', name: 'ReportQueryDefinitionEN', component: () => import('@/modules/admin/pages/ReportQueryDefinitionsPage.vue'),
    },
    { path: 'report-querydefinition-fr', name: 'ReportQueryDefinitionFR', component: () => import('@/modules/admin/pages/ReportQueryDefinitionsPage.vue'),
    },

     { path: 'salutation/3', name: 'SalutationEN', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },
    { path: 'salutation-fr/3', name: 'SalutationFR', component: () => import('@/modules/admin/pages/ThemeComponentOps.vue'),
    },

    //------------Jobs and applications Operations---------------------------------
    //-job applications
    { path: 'job_offer_creation', name: 'jobApplicationEN', component: () => import('@/modules/admin/pages/CreatejobofferOps.vue'),
    },
    { path: 'creation_d_offre_d_emploi', name: 'jobApplicationFR', component: () => import('@/modules/admin/pages/CreatejobofferOps.vue'),
    },

    { path: 'functional-permissions', name: 'PermissionsEN', component: () => import('@/modules/admin/pages/FunctionalPermissions.vue'),
    },
    { path: 'functional-permissions-fr', name: 'PermissionsFR', component: () => import('@/modules/admin/pages/FunctionalPermissions.vue'),
    },

    //-Generic Images
    { path: 'generic_images', name: 'genericImagesEN', component: () => import('@/modules/admin/pages/GenericImagesOps.vue'),
    },
    { path: 'images_generiques', name: 'genericImagesFR', component: () => import('@/modules/admin/pages/GenericImagesOps.vue'),
    },

      //-Generic Images
    { path: 'book-appointment', name: 'BookAppointmentEN', component: () => import('@/modules/admin/pages/NbAppointmentDashboard.vue'),
      meta: { public: true }
    },
    { path: 'reserver-un-rendez-vous', name: 'BookAppointmentFR', component: () => import('@/modules/admin/pages/NbAppointmentDashboard.vue'),
    },
 

    //-CLINICAL CATEGORY
    { path: 'clinical-category/1', name: 'ClinicalCategoryEN', component: () => import('@/modules/admin/pages/ClinicalOrderCatType.vue'),
    },
    { path: 'clinical-category-fr/1', name: 'ClinicalCategoryFR', component: () => import('@/modules/admin/pages/ClinicalOrderCatType.vue'),
    },

    //-CLINICAL TYPE
    { path: 'clinical-type/2', name: 'ClinicalTypeEN', component: () => import('@/modules/admin/pages/ClinicalOrderCatType.vue'),
    },
    { path: 'clinical-type-fr/2', name: 'ClinicalTypeFR', component: () => import('@/modules/admin/pages/ClinicalOrderCatType.vue'),
    },

    { path: 'reschedule/:token?', name: 'RescheduleAppointmentEN', component: () => import('@/modules/admin/pages/NbAppointmentDashboardReschedule.vue'),
    },
    { path: 'reschedule/:token?', name: 'RescheduleAppointmentFR', component: () => import('@/modules/admin/pages/NbAppointmentDashboardReschedule.vue'),
    },

    { path: 'calendar/view', name: 'CalendarViewEN', component: () => import('@/modules/admin/pages/AppointmentDashboardNew.vue'),
    },
    { path: 'calendrier/vue', name: 'CalendarViewFR', component: () => import('@/modules/admin/pages/AppointmentDashboardNew.vue'),
    },

    { path: 'stripe-configuration', name: 'StripeConfigPage', component: () => import('@/modules/admin/pages/StripeConfigurationPage.vue'),},
    { path: 'stripe-configuration-fr', name: 'StripeConfigPageFR', component: () => import('@/modules/admin/pages/StripeConfigurationPage.vue'),},

    { path: 'stripe-hosting-configuration', name: 'StripeHostingConfigPage', component: () => import('@/modules/admin/pages/HostingStripeConfiguration.vue'),},
    { path: 'stripe-hosting-configuration-fr', name: 'StripeHostingConfigPageFR', component: () => import('@/modules/admin/pages/HostingStripeConfiguration.vue'),},

       //-----------------OPERATIONS ROUTES------------------------------------
  
    //-DJANGO REST API
    { path: 'upload-ai-search/1', name: 'UploadAISearchEN', component: () => import('@/modules/admin/pages/DjangoAI.vue'),

    },
     { path: 'upload-ai-search-fr/1', name: 'UploadAISearchFR', component: () => import('@/modules/admin/pages/DjangoAI.vue'),
    },
    { path: 'preview-ai-search/2', name: 'PreviewAISearchEN', component: () => import('@/modules/admin/pages/DjangoAI.vue'),
    },
     { path: 'preview-ai-search/2', name: 'PreviewAISearchFR', component: () => import('@/modules/admin/pages/DjangoAI.vue'),
    },
    { path: 'create-list-ai-search/3', name: 'CreateListAISearchEN', component: () => import('@/modules/admin/pages/DjangoAI.vue'),
    },
     { path: 'create-list-ai-search/3', name: 'CreateListAISearchFR', component: () => import('@/modules/admin/pages/DjangoAI.vue'),
    },
    { path: 'create-update-ai-search/4', name: 'CreateUpdateAISearchEN', component: () => import('@/modules/admin/pages/DjangoAI.vue'),
    },
     { path: 'create-update-ai-search/4', name: 'CreateUpdateAISearchFR', component: () => import('@/modules/admin/pages/DjangoAI.vue'),
    },

    { path: 'fq-chat-topics/1', name: 'FQChatTopicsEN', component: () => import('@/modules/admin/pages/FQAIChatbot.vue'),
    },
    { path: 'fq-chat-topics-fr/1', name: 'FQChatTopicsFR', component: () => import('@/modules/admin/pages/FQAIChatbot.vue'),
    },
    { path: 'fq-chat-category/2', name: 'FQChatCategoryEN', component: () => import('@/modules/admin/pages/FQAIChatbot.vue'),
    },
    { path: 'fq-chat-category-fr/2', name: 'FQChatCategoryFR', component: () => import('@/modules/admin/pages/FQAIChatbot.vue'),
    },
    { path: 'fq-chat-create-update/3', name: 'FQChatCreateUpdateEN', component: () => import('@/modules/admin/pages/FQAIChatbot.vue'),
    },
    { path: 'fq-chat-create-update-fr/3', name: 'FQChatCreateUpdateFR', component: () => import('@/modules/admin/pages/FQAIChatbot.vue'),
    },
    { path: 'video-converter', name: 'VideoConverterEN', component: () => import('@/modules/admin/pages/VideoConverter.vue'),
    },
    { path: 'video-converter', name: 'VideoConverterFR', component: () => import('@/modules/admin/pages/VideoConverter.vue'),
    },
    { path: 'all-in-one-subscription-crud', name: 'SubscriptionCRUDEN', component: () => import('@/modules/admin/pages/SubscriptionCrudAllInOne.vue'),
    },
    { path: 'all-in-one-subscription-crud-fr', name: 'SubscriptionCRUDFR', component: () => import('@/modules/admin/pages/SubscriptionCrudAllInOne.vue'),
    },


    

    { path: 'login-images/4', name: 'LoginImagesEN', component: () => import('@/modules/admin/pages/FQAIChatbot.vue'),
    },
    { path: 'login-images-fr/4', name: 'LoginImagesFR', component: () => import('@/modules/admin/pages/FQAIChatbot.vue'),
    },
    
    {path: 'blog-category/1', name: 'BlogCategoryAdminEN', component: () => import('@/modules/admin/components/BlogCategory.vue')},
    {path: 'blog-category-fr/1', name: 'BlogCategoryAdminFR', component: () => import('@/modules/admin/components/BlogCategory.vue')},
    {path: 'blog-group/2', name: 'BlogGroupsAdminEN', component: () => import('@/modules/admin/components/BlogGroups.vue')},
    {path: 'blog-group-fr/2', name: 'BlogGroupsAdminFR', component: () => import('@/modules/admin/components/BlogGroups.vue')},
    {path: 'blog-topic/3', name: 'BlogTopicsAdminEN', component: () => import('@/modules/admin/components/BlogTopics.vue')},
    {path: 'blog-topic-fr/3', name: 'BlogTopicsAdminFR', component: () => import('@/modules/admin/components/BlogTopics.vue')},
    {path: 'blog-contributors/4', name: 'BlogContributorsAdminEN', component: () => import('@/modules/admin/components/BlogContributors.vue')},
    {path: 'blog-contributors-fr/4', name: 'BlogContributorsAdminFR', component: () => import('@/modules/admin/components/BlogContributors.vue')},
    {path: 'blog-content/5', name: 'BlogContentAdminEN', component: () => import('@/modules/admin/components/BlogContent.vue')},
    {path: 'blog-content-fr/5', name: 'BlogContentAdminFR', component: () => import('@/modules/admin/components/BlogContent.vue')},

    {path: 'tenant-help-center', name: 'GlobalTenantHelpCenterEN', component: () => import('@/modules/admin/pages/GlobalHelp-HelpCenter.vue')},
    {path: 'tenant-help-center-fr', name: 'GlobalTenantHelpCenterFR', component: () => import('@/modules/admin/pages/GlobalHelp-HelpCenter.vue')},
    
    {path: 'tenant-help-category/1', name: 'BlogTenantCategoryAdminEN', component: () => import('@/modules/admin/components/GlobalHelpCategory.vue')},
    {path: 'tenant-help-fr/1', name: 'BlogTenantCategoryAdminFR', component: () => import('@/modules/admin/components/GlobalHelpCategory.vue')},
    {path: 'tenant-help-group/2', name: 'BlogTenantGroupsAdminEN', component: () => import('@/modules/admin/components/GlobalHelpGroups.vue')},
    {path: 'tenant-help-group-fr/2', name: 'BlogTenantGroupsAdminFR', component: () => import('@/modules/admin/components/GlobalHelpGroups.vue')},
    {path: 'tenant-help-topic/3', name: 'BlogTenantTopicsAdminEN', component: () => import('@/modules/admin/components/GlobalHelpTopics.vue')},
    {path: 'tenant-help-topic-fr/3', name: 'BlogTenantTopicsAdminFR', component: () => import('@/modules/admin/components/GlobalHelpTopics.vue')},
    {path: 'tenant-help-contributors/4', name: 'BlogTenantContributorsAdminEN', component: () => import('@/modules/admin/components/GlobalHelpContributors.vue')},
    {path: 'tenant-help-contributors-fr/4', name: 'BlogTenantContributorsAdminFR', component: () => import('@/modules/admin/components/GlobalHelpContributors.vue')},
    {path: 'tenant-help-content/5', name: 'BlogTenantContentAdminEN', component: () => import('@/modules/admin/components/GlobalHelpContent.vue')},
    {path: 'tenant-help-content-fr/5', name: 'BlogTenantContentAdminFR', component: () => import('@/modules/admin/components/GlobalHelpContent.vue')},
    
    {path: 'subscription-plan', name: 'SubscriptionPlanEN', component: () => import('@/modules/admin/pages/StripePaymentPlan.vue'),},
    {path: 'subscription-plan-fr', name: 'SubscriptionPlanFR', component: () => import('@/modules/admin/pages/StripePaymentPlan.vue'),},

    {path: 'generate-invoice', name: 'SubscriptionGenerateInvEN', component: () => import('@/modules/admin/components/SubscriptionInvoices.vue'),},
    // SUBSCRIPTION MODULE ROUTES
    {
      path: 'subscription', name: 'SubscriptionEN', component: () => import('@/modules/admin/pages/SubscriptionView.vue'),},
    {
      path: 'subscription-fr', name: 'SubscriptionFR', component: () => import('@/modules/admin/pages/SubscriptionView.vue'),
    },

    // BILLING SETTINGS
    {
      path: 'billing', name: 'BillingSettingsEN', component: () => import('@/modules/admin/pages/BillingSettings.vue'),
    },
    {
      path: 'billing-fr', name: 'BillingSettingsFR', component: () => import('@/modules/admin/pages/BillingSettings.vue'),
    },

    // SUSPENDED LOCKOUT PAGE
    {
      path: 'suspended', name: 'SuspendedEN', component: () => import('@/modules/admin/pages/SuspendedPage.vue'),

    },
    {
      path: 'suspended-fr', name: 'SuspendedFR', component: () => import('@/modules/admin/pages/SuspendedPage.vue'),
    },

   
    //-----------------Clients Related ROUTES------------------------------------
  
    //-DJANGO REST API
    { path: 'clients-related-setup', name: 'PatientSetupEN', component: () => import('@/modules/admin/pages/PatientRefFilesSetup.vue'),
    },
     { path: 'parametres lies aux clients', name: 'PatientSetupFR', component: () => import('@/modules/admin/pages/PatientRefFilesSetup.vue'),
    },
    // Hosting
    {
      path: 'provisioning', name: 'ProvisionEN', component: () => import('@/modules/admin/pages/HostingPlanForm.vue'),
    },
    {
      path: 'provisioning-fr', name: 'ProvisionFR', component: () => import('@/modules/admin/pages/HostingPlanForm.vue'),
    },

    // Dynamic pages
    {
      path: 'dynamic-page', name: 'DynamicPageEN', component: () => import('@/modules/admin/pages/DynamicPage.vue'),
    },
    {
      path: 'dynamic-page-fr', name: 'DynamicPageFR', component: () => import('@/modules/admin/pages/DynamicPage.vue'),
    },

    {
      path: 'subscription-plan-features', name: 'SubPlanFeaturesEN', component: () => import('@/modules/admin/pages/SubscriptionPlanFeatures.vue'),
    },
    {
      path: 'subscription-plan-features-fr', name: 'SubPlanFeaturesFR', component: () => import('@/modules/admin/pages/SubscriptionPlanFeatures.vue'),
    },
    {
      path: 'subscription-plan-features-popups', name: 'SubPlanFeaturesPopupEN', component: () => import('@/modules/admin/pages/SubscriptionPlanFeaturesPopup.vue'),
    },
    {
      path: 'subscription-plan-features-popups-fr', name: 'SubPlanFeaturesPopupFR', component: () => import('@/modules/admin/pages/SubscriptionPlanFeaturesPopup.vue'),
    },
    {
      path: 'hosting-subscription-plans-admin', name: 'HostingSubPlanEN', component: () => import('@/modules/admin/pages/HostingSubscriptionPlansAdmin.vue'),
    },
    {
      path: 'hosting-subscription-plans-admin-fr', name: 'HostingSubPlanFR', component: () => import('@/modules/admin/pages/HostingSubscriptionPlansAdmin.vue'),
    },
              // STRIPE SUCCESS PAGE
      {
        path: 'stripe-success', name: 'StripeSuccessAdminEN', component: () => import('@/modules/admin/pages/StripeSuccessPage.vue'),
      },
      {
        path: 'stripe-success-fr', name: 'StripeSuccessAdminFR', component: () => import('@/modules/admin/pages/StripeSuccessPage.vue'),
      },

      {
        path: 'seo-groups-&-meta', name: 'SEOGroupsMetaAdminEN', component: () => import('@/modules/admin/pages/SeoManagement.vue'),
      },
      {
        path: 'seo-groups-&-meta-fr', name: 'SEOGroupsMetaAdminFR', component: () => import('@/modules/admin/pages/SeoManagement.vue'),
      },
      { path: "seo-rows-create", name: "SeoRowCreate", component: () => import("@/components/SeoRowCreate.vue"),},

      // STRIPE CANCEL PAGE
      {
        path: 'stripe-cancel', name: 'StripeCancelAdminEN', component: () => import('@/modules/admin/pages/StripeCancelPage.vue'),
      },
      {
        path: 'stripe-cancel-fr', name: 'StripeCancelAdminFR', component: () => import('@/modules/admin/pages/StripeCancelPage.vue'),
      },
      // Component PAGE
      {
        path: 'component-catalog-page', name: 'ComponentCatalogAdminEN', component: () => import('@/modules/admin/pages/ComponentCatalogPage.vue'),
      },
      {
        path: 'component-catalog-page-fr', name: 'ComponentCatalogAdminFR', component: () => import('@/modules/admin/pages/ComponentCatalogPage.vue'),
      },
      // MdiIcon PAGE
      {
        path: 'mdi-icon-catalog', name: 'MdiIconCatalogAdminEN', component: () => import('@/modules/admin/pages/MdiIconCatalogPage.vue'),
      },
      {
        path: 'mdi-icon-catalog-fr', name: 'MdiIconCatalogAdminFR', component: () => import('@/modules/admin/pages/MdiIconCatalogPage.vue'),
      },
      // HostingPlanAddons PAGE
      {
        path: 'hosting-plan-addon', name: 'HostingPlanAddonsEN', component: () => import('@/modules/admin/pages/HostingPlanAddons.vue'),
      },
      {
        path: 'hosting-plan-addon-fr', name: 'MHostingPlanAddonsFR', component: () => import('@/modules/admin/pages/HostingPlanAddons.vue'),
      },



    {
      path: "billing-dashboard",
      component: () => import("@/modules/admin/billing/BillingLayout.vue"),
        children: [
          { path: '', name: 'BillingOverviewEN', component: () => import("@/modules/admin/billing/layout/Overview/BillingOverviewPage.vue")},
          { path: 'invoices-list', name: 'InvoicesEN', component: () => import("@/modules/admin/billing/components/invoice-list/InvoiceListPage.vue")},
          { path: 'invoices-list-fr', name: 'InvoicesFR', component: () => import("@/modules/admin/billing/components/invoice-list/InvoiceListPage.vue")},
          { path: 'invoices-list-details/:id', name: 'InvoicesIDEN', component: () => import("@/modules/admin/billing/components/invoice-details/InvoiceDetailPage.vue"), props: true},
          { path: 'invoices-list-fr-details/:id', name: 'InvoicesIDFR', component: () => import("@/modules/admin/billing/components/invoice-details/InvoiceDetailPage.vue"), props: true},

          { path: 'payment-success', name: 'PaymentSuccessEN', component: () => import("@/modules/admin/billing/components/BillingPaymentSuccess.vue")},
          { path: 'payment-success-fr', name: 'PaymentSuccessFR', component: () => import("@/modules/admin/billing/components/BillingPaymentSuccess.vue")},
          { path: 'payment-cancel', name: 'PaymentCancelEN', component: () => import("@/modules/admin/billing/components/BillingPaymentCancel.vue")},
          { path: 'payment-cancel-fr', name: 'PaymentCancelFR', component: () => import("@/modules/admin/billing/components/BillingPaymentCancel.vue")},
        ]
      }

      ]
    },
    {
  path: "/:lang(en|fr)/my-dashboard",

  component: CustomerDashboardLayout,

  meta: {
    layout: CustomerDashboardLayout,
    requiresAuth: true
  },

  children: [
    // ============================================================
    // CUSTOMER DASHBOARD HOME
    // ============================================================

    {
      path: "",

      name: "CustomerDashboard",

      component: () =>
        import(
          "@/modules/dashboard/pages/CustomerDashboardHome.vue"
        ),

      meta: {
        title: "Overview"
      }
    },

    // ============================================================
    // MY ORDERS
    // ============================================================

    {
      path: "orders",

      name: "CustomerOrders",

      component: () =>
        import(
          "@/modules/dashboard/components/CustomerDashboardSection.vue"
        ),

      meta: {
        title: "My Orders",

        description:
          "Review your purchases and order history.",

        icon:
          "mdi-cart-outline"
      }
    },

    // ============================================================
    // MY INVOICES
    //
    // We already have a real invoice page, so use it directly.
    // ============================================================

    {
      path: "invoices",

      name: "CustomerInvoices",

      component: () =>
        import(
          "@/modules/dashboard/pages/MyInvoicesView.vue"
        ),

      meta: {
        title: "My Invoices"
      }
    },

    // ============================================================
    // PAYMENT HISTORY
    // ============================================================

    {
      path: "payment-history",

      name: "CustomerPaymentHistory",

      component: () =>
        import(
          "@/modules/dashboard/components/CustomerDashboardSection.vue"
        ),

      meta: {
        title: "Payment History",

        description:
          "Review completed payments and transaction history.",

        icon:
          "mdi-credit-card-outline"
      }
    },

    // ============================================================
    // MEMBERSHIP
    // ============================================================

    {
      path: "membership",

      name: "CustomerMembership",

      component: () =>
        import(
          "@/modules/dashboard/components/CustomerDashboardSection.vue"
        ),

      meta: {
        title: "Membership",

        description:
          "View your membership, reward points and benefits.",

        icon:
          "mdi-medal-outline"
      }
    },

    // ============================================================
    // APPOINTMENTS
    // ============================================================

    {
      path: "appointments",

      name: "CustomerAppointments",

      component: () =>
        import(
          "@/modules/dashboard/pages/AppointmentMgmt.vue"
        ),

      meta: {
        title: "Appointments",
      }
    },

    // ============================================================
    // BOOK APPOINTMENT
    // ============================================================

    {
      path: "book-appointment",

      name: "CustomerBookAppointment",

      component: () =>
        import(
          "@/modules/dashboard/pages/NbAppointmentDashboard.vue"
        ),

      meta: {
        title: "Book Appointment",
      }
    },

    // ============================================================
    // APPOINTMENT HISTORY
    // ============================================================

    {
      path: "appointment-history",

      name: "CustomerAppointmentHistory",

      component: () =>
        import(
          "@/modules/dashboard/pages/AppointmentMgmt.vue"
        ),
    },

    // ============================================================
    // INSURANCE
    // ============================================================

    {
      path: "insurance",

      name: "CustomerInsurance",

      component: () =>
        import(
          "@/modules/dashboard/components/CustomerDashboardSection.vue"
        ),
    },

    // ============================================================
    // ADDRESSES
    // ============================================================

    {
      path: "addresses",

      name: "CustomerAddresses",

      component: () =>
        import(
          "@/modules/dashboard/components/CustomerDashboardSection.vue"
        ),
    },

    // ============================================================
    // MESSAGES
    // ============================================================

    {
      path: "messages",

      name: "CustomerMessages",

      component: () =>
        import(
          "@/modules/dashboard/pages/SendEmail.vue"
        ),
    },

    // ============================================================
    // PROFILE
    // ============================================================

    {
      path: "profile",

      name: "CustomerProfile",

      component: () =>
        import(
          "@/modules/dashboard/pages/EditUserProfile.vue"
        ),
    },

    // ============================================================
    // SETTINGS
    // ============================================================

    {
      path: "settings",

      name: "CustomerSettings",

      component: () =>
        import(
          "@/modules/dashboard/components/CustomerDashboardSection.vue"
        ),
    },

    // ============================================================
    // ASSESSMENTS
    // ============================================================

    {
      path: "assessment",

      name: "CustomerAssessment",

      component: () =>
        import(
          "@/modules/dashboard/pages/AssessmentPage.vue"
        ),
    },

    {
      path: "assessment-results",

      name: "CustomerAssessmentResults",

      component: () =>
        import(
          "@/modules/dashboard/pages/AssessmentResult.vue"
        ),
    },

    // ============================================================
    // MEDICAL NOTES
    // ============================================================

    {
      path: "medical-notes",

      name: "CustomerMedicalNotes",

      component: () =>
        import(
          "@/modules/dashboard/pages/MedicalNotes.vue"
        ),
    },

    // ============================================================
    // PATIENT / CLINICAL INVOICE
    // ============================================================

    {
      path: "client-invoice",

      name: "CustomerPatientInvoice",

      component: () =>
        import(
          "@/modules/dashboard/pages/InvoiceRpt.vue"
        ),
    },

    // ============================================================
    // MEETINGS
    // ============================================================

    {
      path: "join-meeting",

      name: "CustomerJoinMeeting",

      component: () =>
        import(
          "@/modules/dashboard/components/jitsimeeting/MeetingRoom.vue"
        ),
    },

    {
      path: "zoom/join/:meetingId",

      name: "CustomerZoomSdkJoin",

      component: () =>
        import(
          "@/modules/dashboard/pages/ZoomMeetingFull.vue"
        ),
    },

    {
      path: "meeting/:meetingId",

      name: "CustomerAttendeeMeeting",

      component: () =>
        import(
          "@/modules/dashboard/pages/ZoomMeetingFull.vue"
        ),
    },

    {
      path: "meeting/host/:meetingId",

      name: "CustomerHostMeeting",

      component: () =>
        import(
          "@/modules/dashboard/pages/ZoomMeetingFull.vue"
        ),
    },

    // ============================================================
    // PAYMENT
    // ============================================================

    {
      path: "payments",

      name: "CustomerPayments",

      component: () =>
        import(
          "@/modules/dashboard/pages/StripePayment.vue"
        ),
    },

    // ============================================================
    // STRIPE SUCCESS
    // ============================================================

    {
      path: "stripe-success",

      name: "CustomerStripeSuccess",

      component: () =>
        import(
          "@/modules/dashboard/pages/StripeSuccessPage.vue"
        )
    },

    // ============================================================
    // STRIPE CANCEL
    // ============================================================

    {
      path: "stripe-cancel",

      name: "CustomerStripeCancel",

      component: () =>
        import(
          "@/modules/dashboard/pages/StripeCancelPage.vue"
        )
    }
  ]
},

  //=================FINANCE SETUP ENDPOITNS=====================================//
  //=================
  //=============================================================================//
   {
    path: "/:lang(en|fr)/finance_setup",
    component: FinanceSetupLayout,
    meta: { layout: FinanceSetupLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "FinanceDashboardSetup",
        component: () => import("@/modules/financesetup/pages/FinanceDashboardSetupPage.vue")
      }, 
       {
        path: "account-type-setup",
        name: "AccountTypeSetupEN",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue")
      }, 
       {
        path: "account-type-setup-fr",
        name: "AccountTypeSetupFR",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue")
      },
      {
        path: "account-setup",
        name: "AccountSetupEN",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
      }, 
       {
        path: "account-setup-Fr",
        name: "AccountSetupEN",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue")
      },
       {
        path: "account-category",
        name: "AccountCategoryEN",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
      }, 
        {
        path: "account-category-fr",
        name: "AccountCategoryFR",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
      }, 
      {
        path: "chart-of-account",
        name: "ChartOfAccountEN",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
      },
      {
        path: "chart-of-account-fr",
        name: "ChartOfAccountFR",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
         },
      {
        path: "chart-chart-mapping-rules",
        name: "ChartOfAccountMappingRulesEN",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
      }, 
      {
        path: "chart-chart-mappings-rules-Fr",
        name: "ChartOfAccountMappingRulesFR",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
      },
      {
        path: "chart-chart-mappings",
        name: "ChartOfAccountMappingsEN",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
      }, 
       {
        path: "chart-chart-mappings-Fr",
        name: "ChartOfAccountMappingsFR",
        component: () => import("@/modules/financesetup/pages/AccountTypeSetup.vue"),
         },
      {
        path: "operations",
        name: "OperationsEN",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue"),
           }, 
       {
        path: "operations-fr",
        name: "OperationsFR",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue"),
      },
      {
        path: "project-code",
        name: "ProjectCodeEN",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue"),
      }, 
       {
        path: "project-code-fr",
        name: "ProjectCodeFR",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue"),
        
      },
      {
        path: "cost-centers",
        name: "CostCenterEN",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue")
      }, 
       {
        path: "cost-center-fr",
        name: "CostCenterFR",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue")
      },
       {
        path: "departments",
        name: "DepartmentsEN",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue")
      }, 
       {
        path: "departments-fr",
        name: "DepartmentsFR",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue")
      },
     
       {
        path: "business-partners",
        name: "BusinessPartnersEN",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue")
      }, 
       {
        path: "business-partners-fr",
        name: "BusinessPartnersFR",
        component: () => import("@/modules/financesetup/pages/ReferenceFiles.vue")
      },
        //- Articles setupsdfsf
      { path: 'tax-code', name: 'TaxCodeEN', component: () => import('@/modules/financesetup/pages/TaxCode.vue'),
      },
      { path: 'tax-code-fr', name: 'TaxCodeFR', component: () => import('@/modules/financesetup/pages/TaxCode.vue'),
      },
    ]
   },
 


  //===========================================================================//
  //================= FINANCE SETUP ENDPOITNS
  //=============================================================================//
  {
    path: "/:lang(en|fr)/finance",
    component: FinanceLayout,
    meta: { layout: FinanceLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "FinanceDashboard",
        component: () => import("@/modules/finance/pages/FinanceDashboardPage.vue")
      }, 
      {
        path: "GL-operations",
        name: "GLOperationsEN",
        component: () => import("@/modules/finance/pages/GLJournal.vue")
      }, 
       {
        path: "GL-operations-fr",
        name: "GLOperationsFR",
        component: () => import("@/modules/finance/pages/GLJournal.vue")
      },
        {
          path: 'gl-journals',
          name: 'GLList',
          component: () => import('@/modules/finance/components/GLJournalList.vue'),
        },
        {
          path: 'gl-journals/:id?',
          name: 'GLEdit',
          component: () => import('@/modules/finance/components/GLJournalForm.vue'),
          props: true,
        },

    ]
   },

  //===========================================================================//
  //================= HR ENDPOITNS
  //=============================================================================//
  {
    path: "/:lang(en|fr)/hr",
    component: HrLayout,
    meta: { layout: HrLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "HrDashboard",
        component: () => import("@/modules/hr/pages/HrDashboardPage.vue")
      }, 
    ]
   },

    //===========================================================================//
  //================= HELPDESK
  //=============================================================================//
  {
   path: "/:lang(en|fr)/helpdesk",
    component: HelpdeskLayout,
  children: [
    {
      path: "",
      name: "HelpdeskDashboard",
      component: () =>
        import("@/modules/helpdesk/pages/HelpdeskDashboardPage.vue")
    },

    {
      path: "support-work-flow",
      name: "SupportWorkFlow",
      component: () =>
        import("@/modules/helpdesk/components/SupportWorkflowStatus.vue")
    },
    {
      path: "support-approval-workflow",
      name: "SupportApprovalWorkflow",
      component: () =>
        import("@/modules/helpdesk/components/SupportApprovalWorkflow.vue")
    },
    {
      path: "support-assignment-group",
      name: "SupportAssignmentGroup",
      component: () =>
        import("@/modules/helpdesk/components/SupportAssignmentGroup.vue")
    },
     {
      path: "support-assignment-management",
      name: "SupportAssignmentRuleManagement",
      component: () =>
        import("@/modules/helpdesk/components/SupportAssignmentRuleManagement.vue")
    },
     {
      path: "support-case-type-management",
      name: "SupportCaseTypeManagement",
      component: () =>
        import("@/modules/helpdesk/components/SupportCaseTypeManagement.vue")
    },
     {
      path: "support-category",
      name: "SupportCategoryManagement",
      component: () =>
        import("@/modules/helpdesk/components/SupportCategoryManagement.vue")
    },
     {
      path: "support-configuration-item",
      name: "SupportConfigurationItemManagement",
      component: () =>
        import("@/modules/helpdesk/components/SupportConfigurationItemManagement.vue")
    },
    {
      path: "support-SLA-policy",
      name: "SupportSlaPolicyManagement",
      component: () =>
        import("@/modules/helpdesk/components/SupportSlaPolicyManagement.vue")
    },
    {
      path: "support-service",
      name: "SupportServiceManagement",
      component: () =>
        import("@/modules/helpdesk/components/SupportServiceManagement.vue")
    },
    {
      path: "support-business-hours",
      name: "SupportBusinessHoursManagement",
      component: () =>
        import("@/modules/helpdesk/components/SupportBusinessHoursManagement.vue")
    },   
    {
      path: "support-configuration-item-type",
      name: "SupportConfigurationItemTypeManagement",
      component: () =>
        import("@/modules/helpdesk/components/SupportConfigurationItemTypeManagement.vue")
    },
     {
      path: "support-ticket-request",
      name: "SupportTicketRequest",
      component: () =>
        import("@/modules/helpdesk/pages/SupportTicketRequest.vue")
    },
      {
      path: "user-support-ticket-request",
      name: "SupportTicketRequestUser",
      component: () =>
        import("@/modules/helpdesk/pages/SupportTicketRequestUser.vue")
    },
    {
      path: "support-ticket-management",
      name: "SupportTicketManagement",
      component: () =>
        import("@/modules/helpdesk/pages/TicketManagment.vue")
    },
    {
      path: "my-support-tickets",
      name: "MySupportTickets",
      component: () =>
        import(
          "@/modules/helpdesk/pages/MySupportTickets.vue"
        )
    },

    {
      path: "my-pending-approvals",
      name: "MyPendingApprovals",
      component: () =>
        import(
          "@/modules/helpdesk/pages/MyPendingApprovals.vue"
        )
    },
    {
      path: "approvals-and-membership",
      name: "ApprovalMembership",
      component: () =>
        import(
          "@/modules/helpdesk/pages/ApprovalManagement.vue"
        )
    }
  ]
},

   //===========================================================================//
  //================= INVENTORY AND LOGISTICS ENDPOITNS
  //=============================================================================//
  {
    path: "/:lang(en|fr)/inventory_&_logistics",
    component: InventoryLogisticsLayout,
    meta: { layout: InventoryLogisticsLayout },
    children: [
      {
        path: "",
        name: "InventoryLogisticsDashboard",
        component: () => import("@/modules/inventorylogistics/pages/InventoryLogisticsDashboardPage.vue")
      }, 

      // ========================================================
      // INVENTORY
      // ========================================================

      { path: "items", name: "ItemMasterPage", component: () => import("@/modules/inventorylogistics/pages/ItemMasterPage.vue") },
      { path: "categories", name: "ItemCategoriesPage", component: () => import("@/modules/inventorylogistics/pages/ItemCategoriesPage.vue") },
      { path: "lots", name: "InventoryLotPage", component: () => import("@/modules/inventorylogistics/pages/InventoryLotPage.vue") },
      { path: "warehouses", name: "WarehousePage", component: () => import("@/modules/inventorylogistics/pages/WarehousePage.vue") },

      // ========================================================
      // STOCK OPERATIONS
      // ========================================================

      { path: "stock/receive", name: "StockReceiptPage", component: () => import("@/modules/inventorylogistics/pages/StockReceiptPage.vue") },
      { path: "stock/issue", name: "StockIssuePage", component: () => import("@/modules/inventorylogistics/pages/StockIssuePage.vue") },
      { path: "stock/return", name: "StockReturnPage", component: () => import("@/modules/inventorylogistics/pages/StockReturnPage.vue") },
      { path: "stock/transfer", name: "StockTransferPage", component: () => import("@/modules/inventorylogistics/pages/StockTransferPage.vue") },
      { path: "stock/adjustment", name: "StockAdjustmentPage", component: () => import("@/modules/inventorylogistics/pages/StockAdjustmentPage.vue") },

      // ========================================================
      // SUPPLIER
      // ========================================================

       //-create years
      { path: 'vendor-creation', name: 'VendorEN', component: () => import('@/modules/inventorylogistics/pages/VendorManagement.vue'), 
      },
      { path: 'vendor-creation-fr', name: 'VendorFR', component: () => import('@/modules/inventorylogistics/pages/VendorManagement.vue'), 
      },
      { path: 'terminal-location', name: 'TerminalLocationEN', component: () => import('@/modules/inventorylogistics/pages/PosTerminalLocationsPage.vue'),},
      { path: 'terminal-location-fr', name: 'TerminalLocationFR', component: () => import('@/modules/inventorylogistics/pages/PosTerminalLocationsPage.vue'),},

      // ========================================================
      // INVENTORY CONTROL
      // ========================================================

      { path: "control/quarantine", name: "InventoryQuarantinePage", component: () => import("@/modules/inventorylogistics/pages/InventoryQuarantinePage.vue") },
      { path: "control/recalls", name: "InventoryRecallPage", component: () => import("@/modules/inventorylogistics/pages/InventoryRecallPage.vue") },
      { path: "control/expiring", name: "InventoryExpiringLotsPage", component: () => import("@/modules/inventorylogistics/pages/InventoryExpiringLotsPage.vue") },
      { path: "control/expired", name: "InventoryExpiredLotsPage", component: () => import("@/modules/inventorylogistics/pages/InventoryExpiredLotsPage.vue") },

      // ========================================================
      // REPORTS
      // ========================================================

      { path: "reports/movements", name: "StockMovementPage", component: () => import("@/modules/inventorylogistics/pages/StockMovementPage.vue") },
      { path: "reports/valuation", name: "InventoryValuationPage", component: () => import("@/modules/inventorylogistics/pages/InventoryValuationPage.vue") },
      { path: "reports/warehouse-inventory", name: "WarehouseInventoryPage", component: () => import("@/modules/inventorylogistics/pages/WarehouseInventoryPage.vue") },
      { path: "reports/stock", name: "StockReportsPage", component: () => import("@/modules/inventorylogistics/pages/StockReportsPage.vue") },

      // ========================================================
      // BARCODE
      // ========================================================

      { path: "barcodes", name: "BarcodePage", component: () => import("@/modules/inventorylogistics/pages/BarcodePage.vue") },
      { path: "barcodes/scanner", name: "BarcodeScannerPage", component: () => import("@/modules/inventorylogistics/pages/BarcodeScannerPage.vue") }
    ]
   },

  //===========================================================================//
//================= PAYROLL ENDPOINTS
//===========================================================================//

{
  path: "/:lang(en|fr)/payroll",

  component: PayrollLayout,

  meta: {
    layout: PayrollLayout,
  },

  children: [
    {
      path: "",
      name: "PayrollDashboard",
      component: () =>
        import("@/modules/payroll/pages/PayrollDashboardPage.vue")
    },

    //=======================================================================//
    // EMPLOYEES
    //=======================================================================//

    {
      path: "employees",
      name: "PayrollEmployees",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeePage.vue")
    },

    {
      path: "departments",
      name: "PayrollDepartments",
      component: () =>
        import("@/modules/payroll/pages/resources/DepartmentPage.vue")
    },

    {
      path: "positions",
      name: "PayrollPositions",
      component: () =>
        import("@/modules/payroll/pages/resources/PositionPage.vue")
    },

    {
      path: "jobs",
      name: "PayrollJobs",
      component: () =>
        import("@/modules/payroll/pages/resources/JobPage.vue")
    },

    {
      path: "job-categories",
      name: "PayrollJobCategories",
      component: () =>
        import("@/modules/payroll/pages/resources/JobCategoryPage.vue")
    },
    {
      path: "pay-grade",
      name: "PayrollPayGrade",
      component: () =>
        import("@/modules/payroll/pages/resources/PayGradePage.vue")
    },

    {
      path: "business-units",
      name: "PayrollBusinessUnits",
      component: () =>
        import("@/modules/payroll/pages/resources/BusinessUnitPage.vue")
    },

    {
      path: "cost-centres",
      name: "PayrollCostCentres",
      component: () =>
        import("@/modules/payroll/pages/resources/CostCentrePage.vue")
    },

    {
      path: "work-locations",
      name: "PayrollWorkLocations",
      component: () =>
        import("@/modules/payroll/pages/resources/WorkLocationPage.vue")
    },

    {
      path: "employment-contracts",
      name: "PayrollEmploymentContracts",
      component: () =>
        import("@/modules/payroll/pages/resources/EmploymentContractPage.vue")
    },

    {
      path: "employee-bank-accounts",
      name: "PayrollEmployeeBankAccounts",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeBankAccountPage.vue")
    },

    {
      path: "employee-government-identifiers",
      name: "PayrollEmployeeGovernmentIdentifiers",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeGovernmentIdentifierPage.vue")
    },


    //=======================================================================//
    // TIME & ATTENDANCE
    //=======================================================================//

    {
      path: "timesheets",
      name: "PayrollEmployeeTimesheets",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeTimesheetPage.vue")
    },

    {
      path: "timesheet-entries",
      name: "PayrollEmployeeTimesheetEntries",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeTimesheetEntryPage.vue")
    },

    {
      path: "leave-requests",
      name: "PayrollLeaveRequests",
      component: () =>
        import("@/modules/payroll/pages/resources/LeaveRequestPage.vue")
    },

    {
      path: "leave-types",
      name: "PayrollLeaveTypes",
      component: () =>
        import("@/modules/payroll/pages/resources/LeaveTypePage.vue")
    },

    {
      path: "employee-leave-balances",
      name: "PayrollEmployeeLeaveBalances",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeLeaveBalancePage.vue")
    },

    {
      path: "employee-leave-balance-transactions",
      name: "PayrollEmployeeLeaveBalanceTransactions",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeLeaveBalanceTransactionPage.vue")
    },

    {
      path: "holiday-calendars",
      name: "PayrollHolidayCalendars",
      component: () =>
        import("@/modules/payroll/pages/resources/HolidayCalendarPage.vue")
    },

    {
      path: "holidays",
      name: "PayrollHolidays",
      component: () =>
        import("@/modules/payroll/pages/resources/HolidayPage.vue")
    },


    //=======================================================================//
    // PAYROLL PROCESSING
    //=======================================================================//

    {
      path: "pay-groups",
      name: "PayrollPayGroups",
      component: () =>
        import("@/modules/payroll/pages/resources/PayGroupPage.vue")
    },

    {
      path: "pay-group-employees",
      name: "PayrollPayGroupEmployees",
      component: () =>
        import("@/modules/payroll/pages/resources/PayGroupEmployeePage.vue")
    },

    {
      path: "payroll-periods",
      name: "PayrollPeriods",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollPeriodPage.vue")
    },

    {
      path: "payroll-runs",
      name: "PayrollRuns",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollRunPage.vue")
    },

    {
      path: "run-workspace",
      name: "PayrollRunWorkspace",
      component: () =>
        import("@/modules/payroll/pages/PayrollRunWorkspacePage.vue")
    },

    {
      path: "employee-payroll-results",
      name: "PayrollEmployeePayrollResults",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeePayrollResultPage.vue")
    },

    {
      path: "employee-payroll-result-lines",
      name: "PayrollEmployeePayrollResultLines",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeePayrollResultLinePage.vue")
    },

    {
      path: "employee-payroll-balances",
      name: "PayrollEmployeePayrollBalances",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeePayrollBalancePage.vue")
    },

    {
      path: "payroll-payments",
      name: "PayrollPayments",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollPaymentPage.vue")
    },

    {
      path: "payslips",
      name: "PayrollPayslips",
      component: () =>
        import("@/modules/payroll/pages/resources/PayslipPage.vue")
    },

    {
      path: "payslip-templates",
      name: "PayrollPayslipTemplates",
      component: () =>
        import("@/modules/payroll/pages/resources/PayslipTemplatePage.vue")
    },


    //=======================================================================//
    // DEDUCTIONS & BENEFITS
    //=======================================================================//
     {
      path: "payroll-component-types",
      name: "PayrollComponentsTypes",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollComponentTypePage.vue")
    },
    {
      path: "payroll-components",
      name: "PayrollComponents",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollComponentPage.vue")
    },

    {
      path: "employee-payroll-components",
      name: "PayrollEmployeePayrollComponents",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeePayrollComponentPage.vue")
    },

    {
      path: "employee-deduction-arrangements",
      name: "PayrollEmployeeDeductionArrangements",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeDeductionArrangementPage.vue")
    },

    {
      path: "benefit-plans",
      name: "PayrollBenefitPlans",
      component: () =>
        import("@/modules/payroll/pages/resources/BenefitPlanPage.vue")
    },

    {
      path: "employee-benefit-enrollments",
      name: "PayrollEmployeeBenefitEnrollments",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeBenefitEnrollmentPage.vue")
    },


    //=======================================================================//
    // TAXES & STATUTORY
    //=======================================================================//

    {
      path: "employee-tax-profiles",
      name: "PayrollEmployeeTaxProfiles",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeTaxProfilePage.vue")
    },

    {
      path: "employer-tax-profiles",
      name: "PayrollEmployerTaxProfiles",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployerTaxProfilePage.vue")
    },

    {
      path: "payroll-tax-tables",
      name: "PayrollTaxTables",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollTaxTablePage.vue")
    },

    {
      path: "payroll-tax-brackets",
      name: "PayrollTaxBrackets",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollTaxBracketPage.vue")
    },

    {
      path: "payroll-rules",
      name: "PayrollRules",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollRulePage.vue")
    },

    {
      path: "payroll-component-jurisdiction-rules",
      name: "PayrollComponentJurisdictionRules",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollComponentJurisdictionRulePage.vue")
    },


    //=======================================================================//
    // ACCOUNTING / GL
    //=======================================================================//

    {
      path: "payroll-accounting-profiles",
      name: "PayrollAccountingProfiles",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollAccountingProfilePage.vue")
    },

    {
      path: "payroll-journals",
      name: "PayrollJournals",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollJournalPage.vue")
    },

    {
      path: "payroll-journal-lines",
      name: "PayrollJournalLines",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollJournalLinePage.vue")
    },

    {
      path: "payroll-posting-batches",
      name: "PayrollPostingBatches",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollPostingBatchPage.vue")
    },


    //=======================================================================//
    // YEAR END
    //=======================================================================//

    {
      path: "year-end",
      name: "PayrollYearEnd",
      component: () =>
        import("@/modules/payroll/pages/PayrollYearEndPage.vue")
    },

    {
      path: "year-end-report-definitions",
      name: "PayrollYearEndReportDefinitions",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollYearEndReportDefinitionPage.vue")
    },

    {
      path: "year-end-report-fields",
      name: "PayrollYearEndReportFields",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollYearEndReportFieldPage.vue")
    },

    {
      path: "year-end-field-mappings",
      name: "PayrollYearEndFieldMappings",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollYearEndFieldMappingPage.vue")
    },

    {
      path: "year-end-submissions",
      name: "PayrollYearEndSubmissions",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollYearEndSubmissionPage.vue")
    },

    {
      path: "employee-year-end-statements",
      name: "PayrollEmployeeYearEndStatements",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeYearEndPayrollStatementPage.vue")
    },

    {
      path: "employee-year-end-statement-values",
      name: "PayrollEmployeeYearEndStatementValues",
      component: () =>
        import("@/modules/payroll/pages/resources/EmployeeYearEndPayrollStatementValuePage.vue")
    },


    //=======================================================================//
    // REPORTING
    //=======================================================================//

    {
      path: "reports",
      name: "PayrollReports",
      component: () =>
        import("@/modules/payroll/pages/PayrollReportsPage.vue")
    },


    //=======================================================================//
    // SETTINGS / CONFIGURATION
    //=======================================================================//

    {
      path: "legal-entities",
      name: "PayrollLegalEntities",
      component: () =>
        import("@/modules/payroll/pages/resources/LegalEntityPage.vue")
    },

    {
      path: "csv-import",
      name: "PayrollCsvImport",
      component: () =>
        import("@/modules/payroll/pages/PayrollCsvImportPage.vue")
    },

    {
      path: "diagnostics",
      name: "PayrollDiagnostics",
      component: () =>
        import("@/modules/payroll/pages/PayrollDiagnosticsPage.vue")
    },


    //=======================================================================//
    // AUDIT
    //=======================================================================//

    {
      path: "audit-logs",
      name: "PayrollAuditLogs",
      component: () =>
        import("@/modules/payroll/pages/resources/PayrollAuditLogPage.vue")
    }
  ]
},

  //===========================================================================//
  //================= PROCUREMENT ENDPOINTS
  //===========================================================================//
  {
    path: "/:lang(en|fr)/procurement",
    component: ProcurementLayout,
    meta: { layout: ProcurementLayout, requiresAuth: true },

    children: [
      {
        path: "",
        name: "ProcurementDashboard",
        component: () =>
          import("@/modules/procurement/pages/ProcurementDashboardPage.vue")
      },

      // ---------------------------------------------------------
      // SETUP
      // ---------------------------------------------------------
      {
        path: "suppliers",
        name: "ProcurementSuppliers",
        component: () =>
          import("@/modules/procurement/pages/SuppliersPage.vue")
      },

      {
        path: "categories",
        name: "ProcurementCategories",
        component: () =>
          import("@/modules/procurement/pages/CategoriesPage.vue")
      },

      {
        path: "report-designer",
        name: "ProcurementReportDesigner",
        component: () =>
          import("@/modules/procurement/pages/ProcurementReportDesignerPage.vue")
      },

      // ---------------------------------------------------------
      // REQUISITIONS
      // ---------------------------------------------------------
      {
        path: "requisitions",
        name: "ProcurementRequisitions",
        component: () =>
          import("@/modules/procurement/pages/PurchaseRequisitionsPage.vue")
      },

      // ---------------------------------------------------------
      // PURCHASE ORDERS
      // ---------------------------------------------------------
      {
        path: "orders",
        name: "ProcurementOrders",
        component: () =>
          import("@/modules/procurement/pages/PurchaseOrdersPage.vue")
      },
    ]
  },

  //===========================================================================//
  //================= PRODUCTION ENDPOITNS
  //=============================================================================//
  {
    path: "/:lang(en|fr)/production",
    component: ProductionLayout,
    meta: { layout: ProductionLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "ProductionDashboard",
        component: () => import("@/modules/production/pages/ProductionDashboardPage.vue")
      }, 
    ]
   },

  //===========================================================================//
  //================= SALES ENDPOITNS
  //=============================================================================//
  {
    path: "/:lang(en|fr)/sales",
    component: SalesLayout,
    meta: { layout: SalesLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "SalesDashboard",
        component: () => import("@/modules/sales/pages/SalesDashboardPage.vue")
      }, 
    ]
   },

   //===========================================================================//
  //================= HR ENDPOITNS
  //=============================================================================//
  {
    path: "/:lang(en|fr)/hr",
    component: HrLayout,
    meta: { layout: HrLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "HrDashboard",
        component: () => import("@/modules/hr/pages/HrDashboardPage.vue")
      }, 
    ]
   },

    //===========================================================================//
  //================= CRM ENDPOITNS
  //=============================================================================//
  {
    path: "/:lang(en|fr)/crm",
    component: CrmLayout,
    meta: { layout: CrmLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "CrmDashboard",
        component: () => import("@/modules/crm/pages/CrmDashboardPage.vue")
      }, 
    ]
   },


       //===========================================================================//
  //================= CRM ENDPOITNS dgdgdf
  //=============================================================================//
  {
    path: "/:lang(en|fr)/medical",
    component: ClinicalLayout,
    meta: { layout: ClinicalLayout, requiresAuth: true },
    children: [
      {
        path: "",
        name: "ClinicalDashboard",
        component: () => import("@/modules/clinical/pages/ClinicalDashboardPage.vue")
      }, 
      { path: 'client-visit', name: 'PatientVisitEN', component: () => import('@/modules/clinical/pages/ClientVisit.vue'),
      },
      { path: 'client-visit-fr', name: 'PatientVisitFR', component: () => import('@/modules/clinical/pages/ClientVisit.vue'),
      },
      { path: 'invoice-items', name: 'InvoiceItemsEN', component: () => import('@/modules/clinical/pages/InvoiceItems.vue'),
      },
      { path: 'invoice-items-fr', name: 'InvoiceItemsFR', component: () => import('@/modules/clinical/pages/InvoiceItems.vue'),
      },
      { path: 'invoice', name: 'InvoiceEN', component: () => import('@/modules/clinical/pages/Invoices.vue'),
      },
      { path: 'invoice-fr', name: 'InvoiceFR', component: () => import('@/modules/clinical/pages/Invoices.vue'),
      },
      { path: 'laboratory-request', name: 'LabRequestEN', component: () => import('@/modules/clinical/pages/PatientLabRequest.vue'),
      },
      { path: 'laboratory-request-fr', name: 'LabRequestFR', component: () => import('@/modules/clinical/pages/PatientLabRequest.vue'),
      },
      // { path: 'client-nurse-notes', name: 'PatientsNureseNotesEN', component: () => import('@/modules/clinical/pages/PatientNurseNotes.vue'),
      //   meta: { permission: "NURSENOTE.VIEW" }
      // },
      // { path: 'client-nurse-notes-fr', name: 'PatientsNureseNotesFR', component: () => import('@/modules/clinical/pages/PatientNurseNotes.vue'),
      //   meta: { permission: "NURSENOTE.VIEW" }
      // },
      { path: 'consultation', name: 'ConsultationEN', component: () => import('@/modules/clinical/pages/PatientsConsultation.vue'),
      },
      { path: 'consultation-fr', name: 'ConsultationFR', component: () => import('@/modules/clinical/pages/PatientsConsultation.vue'),
      },
      { path: 'doctor-report', name: 'DoctorReportEN', component: () => import('@/modules/clinical/pages/PatientsDoctorReport.vue'),
      },
      { path: 'doctor-report-fr', name: 'DoctorReportFR', component: () => import('@/modules/clinical/pages/PatientsDoctorReport.vue'),
      },
      { path: 'lab-result', name: 'LabResultEN', component: () => import('@/modules/clinical/pages/PatientsLabResults.vue'),
      },
      { path: 'lab-result-fr', name: 'LabResultFR', component: () => import('@/modules/clinical/pages/PatientsLabResults.vue'),
      },
      { path: 'prescription', name: 'PrescriptionEN', component: () => import('@/modules/clinical/pages/PatientsPrescription.vue'),
      },
      { path: 'prescription-fr', name: 'PrescriptionFR', component: () => import('@/modules/clinical/pages/PatientsPrescription.vue'),
         },
    ]
   },


   ///=====================HOSTING DASHBOARD ROUTES===================================///
    {
      path: "/:lang(en|fr)/hosting-dashboard",

      component: () =>
        import(
          "@/modules/hosting/layout/SaaSHostingLayout.vue"
        ),

      meta: {
        requiresAuth: true
      },

      children: [
        {
          path: "",
          name: "SaaSHostingDashboard",

          component: () =>
            import(
              "@/modules/hosting/pages/HostingDashboardPage.vue"
            ),
        },

        {
          path: "account",
          name: "SaaSHostingAccount",

          component: () =>
            import(
              "@/modules/hosting/pages/HostingAccountPage.vue"
            ),
        },

        {
          path: "subdomains",
          name: "SaaSHostingSubdomains",

          component: () =>
            import(
              "@/modules/hosting/pages/ManagedSubdomainsPage.vue"
            ),
        },

        {
          path: "ssl",
          name: "SaaSHostingSsl",

          component: () =>
            import(
              "@/modules/hosting/components/HostingSsl.vue"
            ),
        },

        {
          path: "subscription",
          name: "SaaSHostingSubscription",

          component: () =>
            import(
              "@/modules/hosting/pages/SubscriptionBillingPage.vue"
            ),
        },

        {
          path: "activity",
          name: "SaaSHostingActivity",

          component: () =>
            import(
              "@/modules/hosting/pages/HostingActivityPage.vue"
            ),
        },
        {
          path: "email",
          name: "PrivateEmails",

          component: () =>
            import(
              "@/modules/hosting/pages/PrivateEmailPage.vue"
            ),

        },
        // ============================================================
        // PUBLIC MAILBOX PASSWORD SETUP
        // ============================================================

        {
          path: "setup-password",
          name: "email-setup-password",

          component: () =>
            import(
              "@/modules/hosting/pages/EmailSetupPasswordPage.vue"
            ),

        },

          // STRIPE CANCEL PAGE
        {path: 'stripe-hosting-success', name: 'StripeSuccessAdminEN', component: () => import('@/modules/admin/pages/StripeSuccessPage.vue'),},
        {path: 'stripe-hosting-cancel', name: 'StripeCancelAdminFR', component: () => import('@/modules/admin/pages/StripeCancelPage.vue'),},

        {path: 'hosting-payment-checkout', name: 'CheckOutEN', component: () => import('@/components/CheckOut.vue'),},
        {path: 'hosting-payment-checkout-fr', name: 'CheckOutFR', component: () => import('@/components/CheckOut.vue'),},

        { path: "hosting/configure/:planId", name: "HostingPackageBuilderEN", component: () => import("@/components/HostingPackageBuilder.vue"),},
        { path: "hosting/configure/:planId", name: "HostingPackageBuilderFR", component: () => import("@/components/HostingPackageBuilder.vue"),},
      ]
    },


    ///=====================POS DASHBOARD ROUTES===================================///
    {
      path: "/:lang(en|fr)/pos-dashboard",

      component: () =>
        import(
          "@/modules/pos/layout/PosLayout.vue"
        ),


      children: [
        {
          path: "",
          name: "PosLayout",

          component: () =>
            import(
              "@/modules/pos/pages/posDashboardPage.vue"
            ),

          meta: {
            hostingMenu: "dashboard"
          }
        },

      ]
    },

  // PUBLIC LAST (catch-all for /:lang/)
  {
    path: "/:lang(en|fr)/",
    component: PublicLayout,
    meta: { layout: PublicLayout, public: true },
    children: [
      {
        path: "",
        name: "PublicHome",
        component: () => import("@/modules/public/pages/HomeView.vue"),
      },
        { path: "create-account", name: "CreateAccount", component: () => import("@/modules/public/components/CreateInitialAccount.vue") },
        { path: t('InitialHostingpage'), name: "InitialHostingPage", component: () => import("@/modules/public/components/InitialHostingPage.vue") },

        {path: 'privacy/privacy-policy', name: 'PrivacyPolicy', component: () => import('@/modules/public/pages/PrivacyPolicy.vue')},
        {path: 'terms/terms-of-service', name: 'TermsOfUse', component: () => import('@/modules/public/pages/TermsOfService.vue')},
        // { path: "client-create-account", name: "PatientCreateAccount", component: () => import("@/modules/public/pages/CreateAccount.vue"), meta: { permission: "APPOINTMENT.CREATE" } },
        // {path: 'contact-us', name: 'contactusEn', component: () => import('@/modules/public/pages/ContactUsnow.vue')},
        // {path: 'contactez-nous', name: 'contactusFR', component: () => import('@/modules/public/pages/ContactUsnow.vue')},
     
        //*************Leadership****************/
        // {path: 'about-us/leadership', name: 'LeadershipEn', component: () => import('@/modules/public/pages/OurLeadership.vue')},
        // {path: 'a-propos/leadership', name: 'LeadershipFr', component: () => import('@/modules/public/pages/OurLeadership.vue')},

        //************Our Mission****************sdadas/
        // {path: 'abouts-us/mission', name: 'whoweareourmission', component: () => import('@/modules/public/pages/OurMission.vue')},
        // {path: 'a-propos/mission', name: 'quinoussomeourmission', component: () => import('@/modules/public/pages/OurMission.vue')},

        // {path: 'abouts-us/values', name: 'whoweareourValues', component: () => import('@/modules/public/pages/OurValues.vue')},
        // {path: 'a-propos/values', name: 'quinoussomeourvalues', component: () => import('@/modules/public/pages/OurValues.vue')},

        // {path: 'abouts-us/vision', name: 'whoweareourVision', component: () => import('@/modules/public/pages/OurVision.vue')},
        // {path: 'a-propos/vision', name: 'quinoussomeourVision', component: () => import('@/modules/public/pages/OurVision.vue')},
        
        //*************Join OUr Team****************/
        // {path: 'who-we-are/about-us/join-our-team', name: 'JoinOurTeamEN', component: () => import('@/modules/public/pages/JoinOurteam.vue')},
        // {path: 'qui-sommes-nous/a-propos/rejoignez-notre-equipe', name: 'RejoingnezNotreEquipFR', component: () => import('@/modules/public/pages/JoinOurteam.vue')},

        // //*************GET CARE LINKS***************/
        // {path: 'get-care/primary-care-access/medication-guidance-and-understanding', name: 'MGUStanding',  component: () => import('@/modules/public/pages/Medicationmanagement.vue')},
        // {path: 'gget-care/primary-care-access/medication-guidance-and-understanding-fr', name: 'MGUStandingFR',  component: () => import('@/modules/public/pages/Medicationmanagement.vue')},

        // {path: 'get-care/primary-care-access/medication-management-and-tracking', name: 'MedTracking', component: () => import('@/modules/public/pages/MedicationTracking.vue')},
        // {path: 'get-care/primary-care-access/medication-management-and-tracking-fr', name: 'MedTrackingFR', component: () => import('@/modules/public/pages/MedicationTracking.vue')},

        // {path: 'get-care/primary-care-access/safety-support-and-medication-use', name: 'SafetySupport', component: () => import('@/modules/public/pages/SafetySupportUsage.vue')},
        // {path: 'get-care/primary-care-access/safety-support-and-medication-use-fr', name: 'SafetySupportFR', component: () => import('@/modules/public/pages/SafetySupportUsage.vue')},

        // {path: 'get-care/crisis-and-immediate-support/consistencty-and-adherence-support', name: 'ConAdhSupport', component: () => import('@/modules/public/pages/ConAdherenceSupport.vue')},
        // {path: 'get-care/crisis-and-immediate-support/consistencty-and-adherence-support-fr', name: 'ConAdhSupportFR', component: () => import('@/modules/public/pages/ConAdherenceSupport.vue')},

        // {path: 'get-care/crisis-and-immediate-support/safety-support-and-continuous-improvement', name: 'SafetySupportImp', component: () => import('@/modules/public/pages/SafetySupportImProve.vue')},
        // {path: 'get-care/crisis-and-immediate-support/safety-support-and-continuous-improvement-fr', name: 'SafetySupportImpFR', component: () => import('@/modules/public/pages/SafetySupportImProve.vue')},
        
        // {path: 'get-care/crisis-and-immediate-support/personalized-medication-oversight', name: 'PerMedOversight', component: () => import('@/modules/public/pages/PersonalizedMedOversight.vue')},
        // {path: 'get-care/crisis-and-immediate-support/personalized-medication-oversight-fr', name: 'PerMedOversightFR', component: () => import('@/modules/public/pages/PersonalizedMedOversight.vue')},
        
        // //*************OUR APPROACH LINKS****************/
        // {path: 'our-approach/compassion-driven-care/human-centered-healing', name: 'HumanCHealing', component: () => import('@/modules/public/pages/HumanCenteredHealing.vue')},
        // {path: 'our-approach/compassion-driven-care/human-centered-healing-fr', name: 'HumanCHealingFR', component: () => import('@/modules/public/pages/HumanCenteredHealing.vue')},

        // {path: 'our-approach/compassion-driven-care/personalized-mental-health-pathways', name: 'PerMentHealthPath', component: () => import('@/modules/public/pages/PersonalizedMentalHealthPath.vue')},
        // {path: 'our-approach/compassion-driven-care/personalized-mental-health-pathways-fr', name: 'PerMentHealthPathFR', component: () => import('@/modules/public/pages/PersonalizedMentalHealthPath.vue')},

        // {path: 'our-approach/compassion-driven-care/guided-emotional-transformation', name: 'GuidedEmoTransformation', component: () => import('@/modules/public/pages/GuidedEmotionalTransformation.vue')},
        // {path: 'our-approach/compassion-driven-care/guided-emotional-transformation-fr', name: 'GuidedEmoTransformationFR', component: () => import('@/modules/public/pages/GuidedEmotionalTransformation.vue')},

        // {path: 'our-approach/evidence-based-excellence/science-backed-mental-health-care', name: 'ScienceBackedMCare', component: () => import('@/modules/public/pages/ScienceBackedMentalHealthCare.vue')},
        // {path: 'our-approach/evidence-based-excellence/science-backed-mental-health-care-fr', name: 'ScienceBackedMCareFR', component: () => import('@/modules/public/pages/ScienceBackedMentalHealthCare.vue')},

        // {path: 'our-approach/evidence-based-excellence/integrated-care-model', name: 'IntCareModel', component: () => import('@/modules/public/pages/IntegratedCareModel.vue')},
        // {path: 'our-approach/evidence-based-excellence/integrated-care-model-fr', name: 'IntCareModelFR', component: () => import('@/modules/public/pages/IntegratedCareModel.vue')},

        // {path: 'our-approach/evidence-based-excellence/safety-ethical-and-transparent-care', name: 'SafEthicTransCare', component: () => import('@/modules/public/pages/SafetyEthicalTranspCare.vue')},
        // {path: 'our-approach/evidence-based-excellence/safety-ethical-and-transparent-care-fr', name: 'SafEthicTransCareFR', component: () => import('@/modules/public/pages/SafetyEthicalTranspCare.vue')},
        
        // {path: 'our-approach/transformational-result/real-progress-you-can-feel', name: 'RelProgYouFeel', component: () => import('@/modules/public/pages/RealProgressYouCanFeel.vue')},
        // {path: 'our-approach/transformational-result/real-progress-you-can-feel-fr', name: 'RelProgYouFeelFR', component: () => import('@/modules/public/pages/RealProgressYouCanFeel.vue')},

        // {path: 'our-approach/transformational-result/sustained-long-term-wellness', name: 'LongTermWellness', component: () => import('@/modules/public/pages/LongTermWellness.vue')},
        // {path: 'our-approach/transformational-result/sustained-long-term-wellness-fr', name: 'LongTermWellnessFR', component: () => import('@/modules/public/pages/LongTermWellness.vue')},

        // {path: 'our-approach/transformational-result/empowering-living', name: 'EmpoweringLiving', component: () => import('@/modules/public/pages/EmpoweredLiving.vue')},
        // {path: 'our-approach/transformational-result/empowering-living-fr', name: 'EmpoweringLivingFR', component: () => import('@/modules/public/pages/EmpoweredLiving.vue')},

        // //**********************OUR INSIGHTS****************/
        // {path: 'our-insights/understanding-the-mind/emotional-patterns-and-awareness', name: 'EmotionPAwareness', component: () => import('@/modules/public/pages/EmotionalPatternAwareness.vue')},
        // {path: 'our-approach/transformational-result/empowering-living-fr', name: 'EmotionPAwarenessFR', component: () => import('@/modules/public/pages/EmotionalPatternAwareness.vue')},

        // {path: 'our-insights/understanding-the-mind/science-of-healing', name: 'ScienceOfHealing', component: () => import('@/modules/public/pages/ScienceOfHealing.vue')},
        // {path: 'our-insights/understanding-the-mind/science-of-healing-fr', name: 'ScienceOfHealingFR', component: () => import('@/modules/public/pages/ScienceOfHealing.vue')},

        // {path: 'our-insights/understanding-the-mind/trauma-memory-and-healing', name: 'TraumaMemHealing', component: () => import('@/modules/public/pages/TraumaMemoryHealing.vue')},
        // {path: 'our-insights/understanding-the-mind/trauma-memory-and-healing-fr', name: 'TraumaMemHealingFR', component: () => import('@/modules/public/pages/TraumaMemoryHealing.vue')},

        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/psychiatric-expertise-explained', name: 'PsychiatricEEXp', component: () => import('@/modules/public/pages/PsychiatricExpertiseExplained.vue')},
        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/psychiatric-expertise-explained-fr', name: 'PsychiatricEEXpFR', component: () => import('@/modules/public/pages/PsychiatricExpertiseExplained.vue')},

        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/research-trends-and-innovation', name: 'ResearchTrendInnovation', component: () => import('@/modules/public/pages/ResearchTrendAndInnovation.vue')},
        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/research-trends-and-innovation-fr', name: 'ResearchTrendInnovationFR', component: () => import('@/modules/public/pages/ResearchTrendAndInnovation.vue')},

        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/insights-from-real-clinical-practice', name: 'InsightRealClinPractice', component: () => import('@/modules/public/pages/InsightRealClinicalPractice.vue')},
        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/insights-from-real-clinical-practice-fr', name: 'InsightRealClinPracticeFR', component: () => import('@/modules/public/pages/InsightRealClinicalPractice.vue')},

        // {path: 'our-insights/growth-resilience-and-long-term-support/building-emotional-resilience', name: 'BuildingER', component: () => import('@/modules/public/pages/BuildingEmotionalResilience.vue')},
        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/building-emotional-resilience-fr', name: 'BuildingERFR', component: () => import('@/modules/public/pages/BuildingEmotionalResilience.vue')},

        // {path: 'our-insights/growth-resilience-and-long-term-support/empowered-living-and-self-descipline', name: 'EmpwLivingDescpline', component: () => import('@/modules/public/pages/EmpoweredLivingSelfDescovery.vue')},
        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/mpowered-living-and-self-descipline-fr', name: 'EmpwLivingDescplineFR', component: () => import('@/modules/public/pages/EmpoweredLivingSelfDescovery.vue')},

        // {path: 'our-insights/growth-resilience-and-long-term-support/continuous-follow-up-and-support', name: 'ContFollowUpSupport', component: () => import('@/modules/public/pages/ContinuousFollowUpSupport.vue')},
        // {path: 'our-insights/clinical-wisdom-and-professional-guidance/continuous-follow-up-and-support-fr', name: 'ContFollowUpSupportFR', component: () => import('@/modules/public/pages/ContinuousFollowUpSupport.vue')},


        //*********** Blogs-and-articles blogs***************/
        // {path: '/blogs-and-articles/blogs', name: 'blogsandarticlesblogs', component: () => import('@/views/BlogsBlog.vue')},
        // {path: '/blogs-et-articles/blogs', name: 'blogsandarticlesblogsFR', component: () => import('@/views/BlogsBlog.vue')},

        //*********** Blogs-and-articles articles***************/
        // {path: 'blogs-and-articles/articles', name: 'blogsAndArticles', component: () => import('@/modules/public/pages/BlogsArticles.vue')},
        // {path: 'blogs-et-articles/articles', name: 'blogsAndArtciclesFR', component: () => import('@/modules/public/pages/BlogsArticles.vue')},

        {path: 'stories-videos-real-experience/video-player/:courseId', name: 'ourVideoPlayerEN', component: () => import('@/modules/public/pages/OurVideoPlayer.vue')},
        {path: 'stories-videos-real-experience/lecteur-video/:courseId', name: 'ourVideoPlayerFR', component: () => import('@/modules/public/pages/OurVideoPlayer.vue')},

 

        // {path: 'stories-videos-real-experience/our-videos', name: 'ourVideos', component: () => import('@/modules/public/pages/OurVideos.vue')},
        // {path: 'stories-videos-real-experience/nos-video', name: 'ourVideosFR', component: () => import('@/modules/public/pages/OurVideos.vue')},

        // {path: 'blogs-&-articles', name: 'BlogCenterEN', component: () => import('@/modules/public/pages/BlogCenter.vue')},
        // {path: 'blogs-&-articles', name: 'BlogCenterFR', component: () => import('@/modules/public/pages/BlogCenter.vue')},
           // {path: '/:lang/help-center', name: 'HelpPCenterEN', component: () => import('@/modules/public/pages/HelpCenter.vue')},
          // {path: '/:lang/help-center-fr', name: 'HelpPCenterFR', component: () => import('@/modules/public/pages/HelpCenter.vue')},

        

        // {path: 'stories-videos-real-experience/articles/:id', name: 'blogsandarticlesarticlesRead', component: () => import('@/modules/public/pages/ReadArticle.vue')},
        // {path: 'stories-videos-real-experience/articles/:id', name: 'blogsandarticlesarticlesFRRead', component: () => import('@/modules/public/pages/ReadArticle.vue')},

        // {path: 'book-appointment', name: 'BookAppointment', component: () => import('@/modules/public/pages/NbAppointmentDashboard.vue')},
        // { path: 'r&#233;server-un-rendez-vous', name: 'BookAppointmentFR', component: () => import('@/modules/public/pages/NbAppointmentDashboard.vue')},

        {path: 'access-denied', name: 'AccessDenied', component: () => import('@/components/AccessDenied')},
        
        {path: 'real-people-real-healing', name: 'BlogCenterEN', component: () => import('@/modules/public/pages/BlogCenter.vue')},
        {path: 'real-people-real-healing-fr', name: 'BlogCenterFR', component: () => import('@/modules/public/pages/BlogCenter.vue')},
      

         // BILLING SETTINGS
        {
          path: 'billing-setup', name: 'BillingEN', component: () => import('@/components/SuspendedPage.vue'),
        },
        {
          path: 'billing-setup-fr', name: 'BillingFR', component: () => import('@/components/SuspendedPage.vue'),
        },

           // Hosting
        {
          path: 'plan-purchase', name: 'ProvisionPublicEN', component: () => import('@/modules/public/pages/ProvisionHosting.vue'),
        },
        {
          path: 'plan-purchase-fr', name: 'ProvisionPublicFR', component: () => import('@/modules/public/pages/ProvisionHosting.vue'),
        },
          {
          path: 'create-account/:id', name: 'ProvisionNowEN', component: () => import('@/modules/public/pages/ProvisionNow.vue'),
        },
         {
          path: "public-appointments",
          name: "PublicAppointmentBooking",
          component: () =>
            import("@/appointments/PublicAppointmentBooking.vue"),
         },
        {
          path: "public-appointments-fr",
          name: "PublicAppointmentBookingFR",
          component: () =>
            import("@/appointments/PublicAppointmentBooking.vue"),
          },

        {
          path: ':pagePath(.*)*',
          name: 'DynamicPublicPage',
          component: () =>
            import('@/modules/public/pages/DynamicPublicPage.vue'),
          meta: {
            public: true,
            dynamicPage: true
          }
        }



    ]
  }
]

// -------------------------------------------------------
// ROUTER INSTANCE
// -------------------------------------------------------
const router = createRouter({
  history: createWebHistory(),
  routes
})

// -------------------------------------------------------
// ROUTER GUARDS
// -------------------------------------------------------



  import { useAuthStore } from "@/store/auth"

router.beforeEach( async (to, from, next) => {
  const firstSegment = to.path.split("/")[1]   // after domain
  const supported = ["en", "fr"]

  // CASE 1 — missing segment → redirect to /en
  if (!firstSegment) {
    return next(`/en${to.path}`)
  }

  // CASE 2 — undefined or invalid → force to /en
  if (firstSegment === "undefined" || !supported.includes(firstSegment)) {
    const cleaned = to.path.replace(`/${firstSegment}`, "")
    return next(`/en${cleaned}`)
  }



  const langStore = useLangStore()  // ✅ safe: called after Pinia is active
  const auth = useAuthStore()
  const lang = langStore.currentLanguage

  const requiresLang = to.matched.some(r => r.path.includes(":lang"))

  // PUBLIC ROUTES
  if (to.meta.public || to.path.includes("/public/")) {
    if (requiresLang && !to.params.lang) {
      return next({ name: to.name, params: { ...to.params, lang } })
    }
    return next()
  }


  // LOGIN REQUIRED
  if (!auth.isLogin) {
    return next({ name: "PublicHome", params: {lang: lang} })
  }

  // ROLE‑BASED REDIRECT AFTER LOGIN
  if (to.path === `/${lang}/` || to.path === `/${lang}`) {
    if (auth.roles === "Admin") {
      return next({ path: `/${lang}/admin` })
    } else {
      return next({ path: `/${lang}/my-dashboard` })
    }
  }

  // FIX MISSING LANG
  if (requiresLang && !to.params.lang) {
    return next({ name: to.name, params: { ...to.params, lang } })
  }

  // TENANT SELECTION
  if (auth.isStaff && !auth.tenantId && to.name !== "SelectTenant") {
    return next({ name: "SelectTenant", params: {lang: lang } })
  }

  // PERMISSION CHECK
  if (to.meta.permission && !auth.hasPermission(to.meta.permission)) {
    return next({ name: "AccessDenied", params: {lang: lang } })
  }

  next()
})

export default router